import { render, staticRenderFns } from "./AddToCartButtonsComponent.vue?vue&type=template&id=4ce3acec"
import script from "./AddToCartButtonsComponent.vue?vue&type=script&lang=js"
export * from "./AddToCartButtonsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports